import _ from 'lodash';

import { AgentAvailability } from 'models/agent_status';
import BeginLogOut from 'actions/user/begin_log_out';
import GatewayErrorSilentHandler from 'scripts/application/lib/gateway_error_silent_handler';
import LogActivity from 'actions/agent_activity/log_activity';
import qconsole from 'scripts/lib/qconsole';
import { updateStore } from 'actions/agent_status/lib/agent_status';

export default class AgentStatusGatewayObserver {
  constructor(context) {
    this.context = context;
    this.errorHandler = new GatewayErrorSilentHandler(this.context);
  }

  onBroadcast(dto) {
    this.handleUpdate(dto);
  }

  onFetchError(err) {
    this.errorHandler.handleCommonErrors(err);
  }

  onFetchSuccess(dto) {
    this.handleUpdate(dto);
  }

  handleUpdate(dto) {
    if (this.isLoggingIn() && _(dto).get('status.availability') === AgentAvailability.OFFLINE) {
      qconsole.log('Ignored OFFLINE agent status during login');
      return;
    }

    let previous = updateStore(this.context, dto);

    let current = this.store.get();
    if (current._version === dto._version && current.getAvailability() === AgentAvailability.OFFLINE) {
      this.context.executeAction(BeginLogOut);
      return;
    }

    this.logPendingActivity(previous);
  }

  isLoggingIn() {
    return (
      this.store.get()._version === 0 &&
      _(this.store.getPending()).get('status.availability') === AgentAvailability.BUSY
    );
  }

  // The following code was transferred from the original implementation.
  // It appears to be logging the last activity when the status changes
  // from OFFLINE because activity logging is turned off in OFFLINE.
  // Why it's needed and why we only care about just a single arbitrary
  // previous activity isn't clear.
  logPendingActivity(previousStatus) {
    if (previousStatus.getAvailability() === AgentAvailability.OFFLINE) {
      this.context.executeAction(LogActivity);
    }
  }

  get store() {
    return this.context.stores.agentStatus;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agent_status/agent_status_gateway_observer.js